import { useState, useEffect } from "react";
import axios from "axios";

export const FOUNDER_KEY = "rs_founder_token";

const founderApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/founder` });

founderApi.interceptors.request.use((c) => {
  const t = sessionStorage.getItem(FOUNDER_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

founderApi.interceptors.response.use((r) => r, (e) => {
  if (e.response?.status === 401 && !/\/(login|verify)$/.test(e.config?.url || "")) {
    sessionStorage.removeItem(FOUNDER_KEY);
    if (window.location.pathname !== "/founder") window.location.assign("/founder");
  }
  return Promise.reject(e);
});

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return fallback;
};

export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
export const fmtD = (s) => (s ? new Date(/^\d{4}-\d{2}-\d{2}$/.test(s) ? `${s}T12:00:00` : s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—");
export const fmtMonth = (m) => (m ? new Date(`${m}-15T12:00:00`).toLocaleDateString(undefined, { month: "short", year: "2-digit" }) : "");
export const daysAgo = (s) => (s ? Math.floor((Date.now() - new Date(s).getTime()) / 86400000) : null);

// GET a founder platform path; reloads when path changes.
export function useFounder(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!path) { return undefined; }
    let on = true;
    setError("");
    founderApi.get(path).then((r) => { if (on) setData(r.data); }).catch((e) => { if (on) setError(errMsg(e, "Couldn't load this data.")); });
    return () => { on = false; };
  }, [path, tick]);
  return { data, error, reload: () => setTick((t) => t + 1) };
}

export async function downloadExport(kind, demo) {
  const r = await founderApi.get(`/platform/export/${kind}?include_demo=${demo}`);
  const bin = atob(r.data.base64);
  const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url; a.download = r.data.filename || `${kind}.csv`; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export default founderApi;
